<div class="header popover-header">
      <span class="header__title">
          <ng-content select="[popover-layout=header]"></ng-content>
      </span>
  <cm-icon
    class="header__close"
    (click)="popover.close()"
    name="close">
  </cm-icon>
</div>
<div class="body">
  <ng-content select="[popover-layout=body]"></ng-content>
</div>
